import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Control, Controller } from "react-hook-form";

interface Props {
  control: Control<any, any>;
  fieldName: string;
  label: string;
  disabled?: boolean;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormMultiCheckbox: React.FC<Props> = (props) => {
  const { control, fieldName, label, disabled, checked, onChange } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(event);
  };

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          disabled={disabled}
          control={
            <Checkbox
              checked={checked}
              onChange={(e) => {
                field.onChange(e.target.checked);
                handleChange(e);
              }}
            />
          }
          label={label}
        />
      )}
    />
  );
};

export default FormMultiCheckbox;
